import { useMediaQuery } from '@mui/material';
import { IBudgetService } from '../../createAndEdit/types';
import DetailServiceObservation from './DetailServiceObservation';
import DetailServiceIMinimizedtemsTable from './DetailServiceIMinimizedtemsTable';

interface IDetailServicesSectionProps {
  service: IBudgetService;
  serviceIndex: number;
}

const MinimizedServicesSection = (props: IDetailServicesSectionProps) => {

  const isMobile = useMediaQuery('(max-width: 768px)');
  const observation = props.service.observation;
  const hasObservation = observation && 
    typeof observation === 'string' && 
    observation.trim() !== '';
  
  return (
    <div className={`border border-gray-200 rounded-md ${isMobile ? 'p-3 my-4' : 'my-6'}`}>
      <div className='display-flex align-items-center padding-10'>
        <p className='text-medium text-size-16 margin-right-10'>Sob medida</p>
        <span className="badge badge-muted text-size-14 text-color-darkest margin-right-10">
            {props.service.serviceName?.trim() || props.service.serviceId}
        </span>
      </div>
      <DetailServiceIMinimizedtemsTable
        items={props.service.items}
        serviceSubtotal={props.service.subtotal}
      />
      {hasObservation && observation && (
        <div className="mt-4 pl-4">
          <DetailServiceObservation observation={observation} />
        </div>
      )}
    </div>
  );
};

export default MinimizedServicesSection;